import { rtkApi, GET_STUDENT_BADGES } from '@/shared/api';
import { SuccessApiResponse } from '@/shared/types/common';
import type { IStudentBadgeShare, IStudentBadgesResponse } from './types';

const badgesApi = rtkApi.injectEndpoints({
  endpoints: (build) => ({
    // GET /student/badges — полученные и запертые приходят одним списком.
    getStudentBadges: build.query<IStudentBadgesResponse, void>({
      query: () => '/student/badges',
      transformResponse: (response: SuccessApiResponse<IStudentBadgesResponse>) => response.data,
      providesTags: [GET_STUDENT_BADGES],
    }),

    /**
     * POST /student/badges/{id}/share — публичная страница достижения.
     * Ссылка постоянная: первый вызов её заводит, дальше отдаётся та же.
     * Только для полученных, за незаработанный сервер вернёт 404.
     */
    shareStudentBadge: build.mutation<IStudentBadgeShare, number>({
      query: (badgeId) => ({ url: `/student/badges/${badgeId}/share`, method: 'POST' }),
      transformResponse: (response: SuccessApiResponse<IStudentBadgeShare>) => response.data,
    }),
  }),
});

export const { useGetStudentBadgesQuery, useShareStudentBadgeMutation } = badgesApi;
